import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledNotificationImg = styled.div`
  margin: 20px auto;
  text-align: center;
`

export const StyledNotificationDesktopImg = styled.div`
  display: none;
  ${themeMedia.tablet`
    display: block;
  `}
`

export const StyledNotificationMobileImg = styled.div`
  ${themeMedia.tablet`
    display: none;
  `}
`

export const StyledNotificationMsg = styled.p`
  text-align: center;
  margin-left: 15px;
  margin-right: 15px;
`

export const StyledNotificationBtn = styled.div`
  text-align: center;
`
